import { Component, OnInit } from '@angular/core';
import { SpecTableComponent } from '../spec-table/spec-table.component';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-ontres-spec-table',
  templateUrl: './ontres-spec-table.component.html',
  styleUrls: ['./ontres-spec-table.component.scss']
})
export class ONTResSpecTableComponent extends SpecTableComponent implements OnInit {

  constructor(
    router: Router,
    activatedRoute: ActivatedRoute,
  ) {
    super(router, activatedRoute);
  }

  ngOnInit() {
    this.displayedColumns = ['name', 'ONT-id', 'ONT-password'];
    super.onInit();
  }

}
